var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.src)?_c('img',{staticClass:"flex-shrink-0",attrs:{"src":_vm.src},on:{"error":function (e) { return _vm.$emit('error', e); }}}):_c('span',{staticClass:"skeleton skeleton--image flex-shrink-0",class:_vm.skeletonClass})}
var staticRenderFns = []

export { render, staticRenderFns }